
import { Component, Vue } from 'vue-property-decorator'
import { getPlacesProvider, setPlacesProvider, PlacesProviderState } from '@/api/placesProvider'

@Component({ name: 'PlacesProvider' })
export default class extends Vue {
  private loading = false
  private saving = false
  private state: PlacesProviderState | null = null
  private selected = ''

  // What each provider can actually answer. Shown next to the choice because
  // the difference is not a detail: switching changes what the app can display.
  private fieldRows = [
    { field: 'name / address / coordinates', google: true, geoapify: true },
    { field: 'category', google: true, geoapify: true },
    { field: 'distance', google: true, geoapify: true },
    { field: 'phone', google: true, geoapify: true },
    { field: 'website', google: true, geoapify: true },
    { field: 'opening hours', google: true, geoapify: true },
    { field: 'rating', google: true, geoapify: false },
    { field: 'rating count', google: true, geoapify: false },
    { field: 'reviews', google: true, geoapify: false },
    { field: 'photos', google: true, geoapify: false },
    { field: 'price level', google: true, geoapify: false },
    { field: 'takeout / delivery / dine-in', google: true, geoapify: false }
  ]

  private created() {
    this.fetch()
  }

  private async fetch() {
    this.loading = true
    try {
      const res: any = await getPlacesProvider()
      this.state = res.data.data
      this.selected = this.state!.active
    } catch (err: any) {
      this.$message.error(this.msg(err))
    } finally {
      this.loading = false
    }
  }

  private confirmSave() {
    this.$confirm(
      this.$t('placesProvider.confirmBody', { name: this.labelFor(this.selected) }) as string,
      this.$t('placesProvider.confirmTitle') as string,
      {
        confirmButtonText: this.$t('placesProvider.continue') as string,
        cancelButtonText: this.$t('placesProvider.cancel') as string,
        type: 'warning'
      }
    ).then(() => this.save()).catch(() => undefined)
  }

  private async save() {
    this.saving = true
    try {
      await setPlacesProvider(this.selected)
      this.$message.success(this.$t('placesProvider.saved') as string)
      this.fetch()
    } catch (err: any) {
      this.$message.error(this.msg(err))
    } finally {
      this.saving = false
    }
  }

  private labelFor(p: string) {
    const map: Record<string, string> = {
      googleplaces: 'Google Places',
      geoapify: 'Geoapify',
      foursquare: 'Foursquare'
    }
    return map[p] || p
  }

  private noteFor(p: string) {
    return this.$t('placesProvider.note_' + p) as string
  }

  private msg(err: any) {
    return err?.response?.data?.status?.message || err?.message || (this.$t('placesProvider.failed') as string)
  }
}
